export const es = {
    messages: {
      notFound: 'Información no encontrada',
      select: 'Seleccione un valor',
      loading: 'Cargando',
      deleteError: 'No se pudo eliminar el registro',
      yes: 'Sí',
      no: 'No',
    },
    pagination: {
      of: 'de',
      issues: {
        singular: 'incidente',
        plural: 'incidentes'
      }
    },
    attachment: {
      delete: {
        title: 'Eliminar Adjunto',
        content: '¿Está seguro de que desea eliminar este adjunto?',
        confirm: 'Eliminar',
        cancel: 'Cancelar'
      }
    },
    tableToolbar: {
      reload: 'Recargar',
      density: 'Densidad',
      densityDefault: 'Predeterminada',
      densityMiddle: 'Media',
      densityCompact: 'Compacta',
      columns: 'Columnas',
      fullscreen: 'Pantalla completa',
      exitFullscreen: 'Salir de pantalla completa'
    },
    buttons: {
      create: 'Crear',
      export: 'Exportar',
      import: 'Importar',
      more: 'Más',
      bulkUpdate: 'Actualización Masiva',
      archiveSelected: 'Archivar Seleccionados',
      refreshData: 'Actualizar Datos',
      clear: 'Limpiar',
      clearAll: 'Limpiar Todo'
    },
    tags: {
      completed: 'Completado',
      pending: 'Pendiente',
      inProgress: 'En Progreso'
    },
    navigation: {
      workspace: 'Workspace',
      appName: 'Giro Web',
      appSwitcher: 'Aplicaciones de Giro',
      selectModule: 'Seleccione un módulo',
      dashboard: 'Dashboard',
      documents: 'Documentos',
      reports: 'Reportes',
      settings: 'Configuración',
      modules: {
        incidents: {
          title: 'Mis Incidentes',
          subtitle: 'Administra tus incidentes'
        },
        events: {
          title: 'Mis Eventos',
          subtitle: 'Administra las pérdidas'
        },
        risks: {
          title: 'Mis Riesgos',
          subtitle: 'Administra tus riesgos'
        },
        plans: {
          title: 'Mis Planes',
          subtitle: 'Administra tus planes'
        },
        indicators: {
          title: 'Mis Indicadores',
          subtitle: 'Administra tus indicadores'
        }
      },
      appSwitcherModules: {
        incidents: 'Incidentes',
        assets: 'Activos',
        actionPlans: 'Planes de Acción',
        risks: 'Riesgos',
        indicators: 'Indicadores',
        suppliers: 'Proveedores',
        lossEvents: 'Eventos de Pérdida',
        bia: 'BIA',
        audit: 'Auditoría'
      },
      subtitles: {
        dashboard: 'Resumen e historial',
        documents: 'Administra tus documentos',
        reports: 'Consulta y crea tus reportes',
        settings: 'Adapta GIRO a tu necesidad'
      },
      userMenu: {
        profile: 'Mi Perfil',
        settings: 'Configuración',
        password: 'Cambiar Contraseña',
        notifications: 'Notificaciones',
        activityLog: 'Registro de Actividad',
        help: 'Ayuda y Soporte',
        logout: 'Cerrar Sesión',
        language: 'Idioma'
      }
    },
    issues: {
      title: 'Incidentes',
      createIssue: 'Crear Incidente',
      saveIssue: 'Guardar Incidente',
      saveApproval: 'Aprobar Incidente',
      exportData: 'Exportar',
      importData: 'Importar',
      filters: 'Filtros',
      status: 'Estado',
      impact: 'Impacto',
      origin: 'Origen',
      dateRange: 'Rango de Fechas',
      searchPlaceholder: 'Buscar incidentes...',
      subtitle: 'Registra, prioriza y resuelve incidentes en toda tu organización',
      date: {
        anytime: 'Cualquier momento',
        olderThanWeek: 'Más de una semana',
        olderThanMonth: 'Más de un mes',
        olderThan6Months: 'Más de 6 meses',
        olderThanYear: 'Más de un año',
        customRange: 'Rango personalizado'
      },
      tabs: {
        all: 'Todos',
        open: 'Abiertos',
        assignedToMe: 'Asignados a mí',
        closed: 'Cerrados',
        archived: 'Archivados'
      },
      stats: {
        openIssues: 'Incidentes abiertos',
        blocking: 'Bloqueantes',
        avgTimeToResolve: 'Tiempo prom. de resolución',
        resolvedThisWeek: 'Resueltos esta semana'
      },
      columns: {
        code: 'Código',
        description: 'Descripción',
        impact: 'Impacto',
        origin: 'Origen',
        effect: 'Efecto',
        dateReport: 'Fecha de Reporte',
        id: 'ID',
        title: 'Título',
        status: 'Estado',
        priority: 'Prioridad',
        assignee: 'Responsable',
        updated: 'Actualizado'
      },
      messages: {
        createSuccess: 'Incidente creado exitosamente',
        createError: 'Error al crear incidente',
        updateSuccess: 'Incidente actualizado exitosamente',
        approvalSuccess: 'El incidente ha sido aprobado exitosamente',
        loadError: 'Error al cargar incidentes',
        searchError: 'Error al buscar incidentes',
        exportInfo: 'Funcionalidad de exportación por implementar',
        importInfo: 'Funcionalidad de importación por implementar'
      },
      options: {
        noOptionsAvailable: 'No hay opciones disponibles',
        status: {
          name: 'Estado',
          filterKey: 'status',
        },
        impact: {
          name: 'Impacto',
          filterKey: 'impact',
        },
        origin: {
          name: 'Origen',
          filterKey: 'origin',
        },
        channelAffected: {
          name: 'Canal Afectado',
          filterKey: 'channelAffected',
        },
        effect: {
          name: 'Efecto',
          filterKey: 'effect',
        },
        issueActionPlan: {
          name: 'Plan de acción',
          filterKey: 'issueActionPlan',
        },
        channelReport: {
          name: 'Canal de Reporte',
          filterKey: 'channelReport',
        },
        resourceAffected: {
          name: 'Recursos Afectados',
          filterKey: 'resourceAffected',
        }
      },
      detail: {
        breadcrumb: {
          issues: 'Incidentes',
          detail: 'Registro del incidente',
          copyLink: 'Copiar enlace',
          linkCopied: 'Enlace copiado'
        },
        title: 'Registro del incidente',
        header: {
          titlePrefix: 'Incidente:',
          newTitle: 'Nuevo incidente',
          subtitle: 'Información detallada del incidente: formulario, evaluación de impacto, aprobación y seguimiento',
          cancel: 'Cancelar'
        },
        navigation: {
          issueDetails: {
            title: 'Incidente',
            panelTitle: 'Registro del Incidente',
            subtitle: 'Editar el incidente'
          },
          approval: {
            title: 'Aprobación',
            panelTitle: 'Aprobación del Incidente',
            subtitle: 'Apruebe el incidente'
          },
          impactAssessment: {
            title: 'Impacto',
            panelTitle: 'Evaluación del Impacto',
            subtitle: 'Impacto del incidente'
          },
          monitoring: {
            title: 'Actividad y Monitoreo',
            panelTitle: 'Monitoreo del Incidente',
            subtitle: 'Seguimiento del incidente'
          },
          actionPlans: {
            title: 'Planes de Acción',
            panelTitle: 'Planes de Acción del Incidente',
            subtitle: 'Planes de acción asociados'
          },
          risks: {
            title: 'Riesgos',
            panelTitle: 'Riesgos asociados al Incidente',
            subtitle: 'Riesgos asociados'
          }
        },
        form: {
          tabs: {
            register: {
              title: 'Datos del Incidente',
            },
            report: {
              title: 'Reportado por',
            }
          },
          sections: {
            basic: 'Información Básica',
            classification: 'Clasificación',
            additional: 'Información Adicional'
          },
          summary: {
            code: 'Código',
            status: 'Estado',
            reportedBy: 'Reportado por',
            reportedOn: 'Fecha de reporte',
            attachments: 'Adjuntos',
            fileCountSuffix: 'archivo(s)',
            maxFiles: 'Máximo 50 archivos, 10MB cada uno'
          },
          code: {
            name: 'Código',
            placeHolder: 'Ingrese el código del incidente',
            validation: {
              required: 'El código es obligatorio'
            }
          },
          title: {
            name: 'Título',
            placeHolder: 'Ingrese el título del incidente',
            validation: {
              required: 'El título es obligatorio'
            }
          },
          origin: {
            name: 'Origen',
            placeHolder: 'Seleccione un origen',
            validation: {
              required: 'El origen es obligatorio'
            }
          },
          effect: {
            name: 'Efecto',
            placeHolder: 'Seleccione un efecto',
            validation: {
              required: 'El efecto es obligatorio'
            }
          },
          status: {
            name: 'Estado',
            placeHolder: 'Seleccione un estado',
            validation: {
              required: 'El estado es obligatorio'
            }
          },
          description: {
            name: 'Descripción',
            placeHolder: 'Ingrese la descripción del incidente',
            validation: {
              required: 'La descripción es obligatoria',
              min: 'La descripción debe tener al menos 10 caracteres',
              max: 'La descripción no debe exceder los 3000 caracteres'
            }
          },
          comments: {
            name: 'Comentarios',
            placeHolder: 'Ingrese comentarios adicionales',
            validation: {
              required: 'El comentario es obligatorio',
              min: 'El comentario debe tener al menos 10 caracteres',
              max: 'El comentario no debe exceder los 1000 caracteres'
            }
          },
          supplier: 'Proveedor involucrado',
          dateReport: {
            name: 'Fecha de Reporte',
            placeHolder: 'Seleccione la fecha de reporte',
            validation: {
              required: 'La fecha de reporte es obligatoria'
            }
          },
          dateInit: {
            name: 'Fecha de Inicio',
            placeHolder: 'Seleccione una fecha'
          },
          dateEnd: {
            name: 'Fecha de Fin',
            placeHolder: 'Seleccione una fecha'
          },
          dateDiscovery: {
            name: 'Fecha de Descubrimiento',
            placeHolder: 'Seleccione una fecha'
          },
          dateMitigation: {
            name: 'Fecha de Mitigación',
            placeHolder: 'Seleccione una fecha'
          },
          issueActionPlan: {
            name: 'Plan de Acción',
            placeHolder: 'Seleccione un plan de acción',
            validation: {
              required: 'Actio plan es obligatorio'
            }
          },
          channelAffected: {
            name: 'Canal Afectado',
            placeHolder: 'Seleccione un canal',
            validation: {
              required: 'El canal  afectado es obligatorio'
            }
          },
          resourceAffected: {
            name: 'Recursos Afectados',
            placeHolder: 'Seleccione un plan de acción',
            validation: {
              required: 'Actio plan es obligatorio'
            }
          },
          process: {
            name: 'Proceso',
            placeHolder: 'Seleccione un proceso',
            validation: {
              required: 'El proceso es obligatorio'
            }
          },
          area: {
            name: 'Area',
            placeHolder: 'Seleccione un área',
            validation: {
              required: 'El área es obligatorio'
            }
          },
          channelReport: {
            name: 'Canal de Reporte',
            placeHolder: 'Seleccione un canal de reporte',
            validation: {
              required: 'Canal de reporte es obligatorio'
            }
          },
          reportingUser: {
            name: 'Usuario que reporta',
            placeHolder: 'Seleccione un usuario',
            validation: {
              required: 'Usuario que reporta es obligatorio'
            }
          },
          rootCause: {
            name: 'Causa raíz',
            placeHolder: 'Ingrese la causa raíz',
            validation: {
              required: 'La causa raíz es obligatoria',
              max: 'La causa raíz no debe exceder los 600 caracteres'
            }
          },
          resolvingArea: {
            name: 'Area resolutora',
            placeHolder: 'Seleccione un área',
            validation: {
              required: 'El área resolutora es obligatorio'
            }
          },
          hasTicket: {
            name: 'Informado al CMF',
            validation: {
              required: 'Informado al CMF es obligatorio'
            }
          },
          typeThreat: {
            name: 'Tipo de amenaza materializada',
            placeHolder: 'Selecciona una opción',
            validation: {
              required: 'El tipo de amenaza es obligatorio'
            }
          },
          typeAssetAffected: {
            name: 'Tipo de activo afectado',
            placeHolder: 'Selecciona una opción',
            validation: {
              required: 'El tipo de activo afectado es obligatoria'
            }
          },
          numberCustomerAffected: {
            name: 'Número de clientes afectados',
            placeHolder: 'Ingrese un número',
            validation: {
              required: 'El número de clientes afectados es obligatorio'
            }
          },
          lossCustomer: {
            name: 'Pérdida asociadas',
            placeHolder: 'Ingrese un monto',
            validation: {
              required: 'La pérdida asociada es obligatoria'
            }
          },
          costMitigation: {
            name: 'Costos de mitigación',
            placeHolder: 'Ingrese un monto',
            validation: {
              required: 'El costo de mitigación es obligatorio'
            }
          },
          file: {
            name: 'Archivos adjuntos',
            placeHolder: 'Seleccione un documento',
            validation: {
              required: 'El documento adjunto es obligatorio'
            }
          }
        }
      },
      approval: {
        by: 'Por',
        assignedTo: 'Asignado a',
        workflow: {
          title: 'Flujo de aprobación'
        },
        steps: {
          submitted: 'Enviado',
          teamLead: 'Aprobación del líder',
          manager: 'Aprobación del gerente pendiente',
          final: 'Revisión final'
        },
        actions: {
          approve: 'Aprobar',
          reject: 'Rechazar',
          addComment: 'Agregar comentario'
        },
        comments: {
          title: 'Agregar comentario'
        },
        summary: {
          title: 'Resumen del incidente',
          code: 'Código',
          status: 'Estado',
          reportedBy: 'Reportado por',
          reportedOn: 'Reportado el'
        },
        messages: {
          approveError: 'No se pudo aprobar el incidente',
          rejectSuccess: 'El incidente fue rechazado',
          rejectError: 'No se pudo rechazar el incidente',
          commentSuccess: 'Comentario agregado'
        },
        form: {
          date: {
            name: 'Fecha de aprobación',
            placeHolder: 'Seleccione una fecha',
            validation: {
              required: 'La fecha de aprobación es requerida'
            }
          },
          user: {
            name: 'Usuario de aprobación',
            placeHolder: 'Seleccione un usuario',
            validation: {
              required: 'El usuario de aprobación es requerido'
            }
          },
          comments: {
            name: 'Comentarios',
            placeHolder: 'Agregue comentarios o notas de aprobación...',
            validation: {
              required: 'El comentario es requerido',
              requiredForReject: 'Se requiere un comentario para rechazar'
            }
          }
        }
      },
      impactAssessment: {
        saveAssessment: 'Guardar evaluación',
        card: {
          title: 'Evaluación de variables de impacto',
          generalAssessment: 'Evaluación general del impacto'
        },
        columns: {
          variable: 'Variable / Grupo',
          assessment: 'Evaluación de Impacto',
          level: 'Nivel de Impacto'
        },
        fields: {
          assessment: {
            placeholder: 'Seleccione un nivel de impacto'
          }
        },
        severity: {
          high: 'Alto',
          mediumHigh: 'Medio-Alto',
          medium: 'Medio',
          lowInfo: 'Bajo / Informativo',
          none: 'Ninguno'
        },
        score: {
          low: 'Bajo',
          information: 'Informativo',
          medium: 'Medio',
          high: 'Alto',
          critical: 'Crítico'
        },
        groups: {
          operationalRisk: 'Riesgo Operacional',
          securityInformation: 'Seguridad e Información',
          businessContinuity: 'Continuidad del Negocio'
        },
        variables: {
          financialImpact: 'Impacto Financiero',
          imageReputation: 'Imagen y Reputación',
          dataConfidentiality: 'Confidencialidad de Datos',
          dataIntegrity: 'Integridad de Datos',
          systemAvailability: 'Disponibilidad del Sistema',
          regulatoryCompliance: 'Cumplimiento Regulatorio',
          accessControl: 'Control de Acceso',
          operationalImpact: 'Impacto Operacional',
          customerImpact: 'Impacto en el Cliente',
          recoveryTimeObjective: 'Objetivo de Tiempo de Recuperación (RTO)',
          serviceLevelImpact: 'Impacto en el Nivel de Servicio'
        },
        messages: {
          saveSuccess: 'Evaluación de impacto guardada',
          saveError: 'No se pudo guardar la evaluación de impacto'
        }
      },
      activity: {
        compose: {
          title: 'Agregar actividad',
          placeholder: 'Agrega un comentario, actualización o nota sobre este incidente...',
          attach: 'Adjuntar archivos',
          post: 'Publicar actividad'
        },
        timeline: {
          title: 'Cronología de actividad',
          empty: 'Sin actividad'
        },
        verbs: {
          commented: 'comentó',
          updated: 'actualizó',
          attached: 'adjuntó archivo'
        },
        summary: {
          title: 'Resumen del incidente',
          code: 'Código',
          status: 'Estado',
          reportedBy: 'Reportado por',
          reportedOn: 'Reportado el'
        },
        stats: {
          title: 'ESTADÍSTICAS DE ACTIVIDAD',
          comments: 'Comentarios',
          attachments: 'Adjuntos',
          lastActivity: 'Última actividad'
        },
        attachment: {
          view: 'Ver',
          download: 'Descargar'
        },
        messages: {
          postSuccess: 'Actividad publicada',
          postError: 'No se pudo publicar la actividad',
          attachmentError: 'No se pudo abrir el archivo adjunto'
        }
      }
    },
    filters: {
      options: {
        noOptionsAvailable: 'No hay opciones disponibles',
      },
      result: 'resultado',
      results: 'resultados',
      found: 'encontrado',
      founds: 'encontrados',
    },
    settings: {
      title: 'Configuración',
      menu: {
        overview: 'Resumen',
        statusIssues: 'Estados',
        groupParameters: 'Grupo de Parámetros',
        impactAssessment: 'Evaluación de Impacto',
        notifications: 'Notificaciones',
        emailServer: 'Servidor de Correo',
        transactionRules: 'Reglas de Transacción'
      },
      content: {
        overview: {
          title: 'Configuración',
          subtitle: 'Gestiona y configura GIRO según tus necesidades',
          description: 'Explora y configura todos los ajustes',
          cardCta: 'Configurar',
          snippets: {
            loading: 'Cargando…',
            statusIssues: '{count} estados',
            groupParameters: 'Próximamente',
            impactAssessment: '{count} grupos de variables',
            notifications: 'Correo y alertas',
            emailServer: 'SMTP y entrega',
            transactionRules: 'Próximamente'
          }
        },
        statusIssues: {
          title: 'Configuración de Estados',
          description: 'Gestionar y configurar los estados',
          filter: {
            entity: 'Entidad',
            all: 'Todas las entidades',
            placeholder: 'Filtrar por entidad'
          },
          buttons: {
            add: 'Agregar estado',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            delete: 'Eliminar'
          },
          columns: {
            code: 'Código',
            name: 'Nombre',
            description: 'Descripción',
            entity: 'Entidad',
            sequence: 'Orden',
            active: 'Activo',
            actions: 'Acciones'
          },
          confirm: {
            deleteTitle: '¿Eliminar estado?',
            deleteDescription: 'Esta acción no se puede deshacer.',
            ok: 'Eliminar',
            cancel: 'Cancelar'
          },
          messages: {
            created: 'Estado creado',
            updated: 'Estado actualizado',
            deleted: 'Estado eliminado',
            saveError: 'No se pudo guardar el estado',
            deleteError: 'No se pudo eliminar el estado',
            empty: 'No se encontraron estados',
            required: 'Requerido'
          }
        },
        groupParameters: {
          title: 'Grupo de parámetros',
          description: 'Configurar grupos de parámetros y valores'
        },
        impactAssessment: {
          title: 'Evaluación de Impacto',
          description: 'Definir criterios de evaluación de impacto',
          header: {
            actions: {
              history: 'Historial de versiones'
            }
          },
          steps: {
            pillFormat: 'Paso {current} de {total}',
            scale: {
              title: 'Escalas',
              subtitle: 'Niveles cualitativos y rangos numéricos'
            },
            variables: {
              title: 'Variables y valores',
              subtitle: 'Catálogo evaluado contra la escala'
            }
          },
          optionPanel: {
            meta: {
              kindGroup: 'grupo',
              kindVariable: 'variable'
            }
          },
          scaleDrawer: {
            previewLabel: 'Vista previa',
            formulaPlaceholder: 'score BETWEEN 0 AND 2',
            formulaHint: 'Usada por el motor de evaluación para clasificar un puntaje numérico en este nivel. Referencia el puntaje como `score`.',
            formulaSuggestions: 'Sugerencias',
            formulaInvalid: 'Fórmula inválida. Permitido: MAX, MIN, SUM, AVERAGE, COUNTIF, AND, OR, la variable `values`, números y operadores de comparación.'
          },
          optionDrawer: {
            bandPickerLabel: 'Escala'
          },
          variableDrawer: {
            typeLabel: 'Tipo de nodo',
            typeGroup: 'Grupo',
            typeVariable: 'Variable'
          },
          sections: {
            scaleBands: {
              title: 'Escalas de impacto',
              description: 'Define los niveles de impacto (por ejemplo Bajo, Medio, Alto) usados en la evaluación, con su color, orden y fórmula.'
            }
          },
          buttons: {
            previous: 'Anterior',
            next: 'Siguiente',
            finish: 'Finalizar'
          },
          tree: {
            title: 'Grupos y variables',
            noVariablesFound: 'No se encontraron variables',
            tags: {
              completed: 'Completado'
            },
            actions: {
              addGroup: 'Agregar grupo',
              editGroup: 'Editar grupo',
              deleteGroupConfirm: '¿Eliminar este grupo? Sus variables y valores también se eliminarán.',
              addVariable: 'Agregar variable',
              editVariable: 'Editar variable',
              deleteVariableConfirm: '¿Eliminar esta variable? Sus valores también se eliminarán.'
            },
            form: {
              groupName: 'Nombre del grupo',
              variableName: 'Nombre de la variable'
            }
          },
          table: {
            columns: {
              name: 'Nombre',
              impact: 'Impacto',
              actions: 'Acciones'
            },
            actions: {
              save: 'Guardar',
              cancel: 'Cancelar',
              edit: 'Editar',
              deleteConfirm: '¿Eliminar este valor?',
              addValue: 'Agregar valor'
            },
            messages: {
              noValuesFound: 'No se encontraron valores para el nodo seleccionado',
              selectNode: 'Por favor seleccione un nodo del árbol'
            }
          },
          formulaTable: {
            columns: {
              description: 'Impacto',
              color: 'Color',
              displayOrder: 'Orden',
              formula: 'Fórmula',
              actions: 'Acciones'
            },
            actions: {
              save: 'Guardar',
              cancel: 'Cancelar',
              edit: 'Editar',
              add: 'Agregar escala',
              delete: 'Eliminar',
              deleteConfirm: '¿Eliminar esta escala?'
            },
            messages: {
              noDataFound: 'No se encontraron opciones de impacto'
            }
          }
        },
        notifications: {
          title: 'Notificaciones',
          description: 'Configurar ajustes y preferencias de notificaciones',
          parameterCode: 'Código del parámetro',
          searchPlaceholder: 'Buscar notificación',
          countActive: '{active} de {total} notificaciones activas',
          empty: 'Ninguna notificación coincide con la búsqueda.',
          filters: {
            all: 'Todas',
            active: 'Activas',
            inactive: 'Inactivas',
            custom: 'Con plantilla propia'
          },
          dirty: {
            unsaved: 'Cambios sin guardar',
            saved: 'Todos los cambios guardados',
            invalidRecipient: 'Falta un destinatario de respaldo válido en “{field}”',
            saveBlocked: 'Ingresa un destinatario de respaldo válido'
          },
          switch: {
            on: 'Sí',
            off: 'No'
          },
          buttons: {
            save: 'Guardar cambios',
            cancel: 'Cancelar'
          },
          messages: {
            saved: 'Configuración de notificaciones guardada',
            saveError: 'No se pudo guardar la configuración',
            loadError: 'No se pudo cargar la configuración de notificaciones',
            reset: 'Cambios descartados'
          },
          banner: {
            emailNotConfigured: 'Configura el servidor de correo para que estas notificaciones puedan enviarse.',
            configureAction: 'Configurar servidor de correo'
          },
          sections: {
            count: '{active} de {total} activas',
            incidents: {
              abbr: 'IN',
              title: 'Incidentes',
              description: 'Notificaciones relacionadas con el ciclo de vida del incidente'
            }
          },
          options: {
            origin_effect: 'Origen o efecto',
            all: 'Todos los campos',
            band_changed: 'Solo si cambia el nivel',
            any: 'Cualquier reevaluación'
          },
          fields: {
            SEND_EMAIL_INCIDENT_CREATED: {
              label: 'Notificar cuando se crea un incidente',
              description: 'Envía una notificación cuando se registra un nuevo incidente.'
            },
            SEND_EMAIL_INCIDENT_MODIFIED: {
              label: 'Notificar cuando se modifica un incidente',
              description: 'Envía una notificación cuando se realiza una modificación al incidente.'
            },
            INCIDENT_MODIFIED_FIELDS: {
              label: 'Campos que disparan la notificación',
              description: 'Envía la notificación de modificación solo al cambiar los campos de origen o efecto, o ante cualquier cambio.'
            },
            SEND_EMAIL_INCIDENT_STATUS_CHANGED: {
              label: 'Notificar cuando cambia de estado un incidente',
              description: 'Envía una notificación cuando el incidente pasa a un estado diferente.'
            },
            SEND_EMAIL_INCIDENT_MONITORING: {
              label: 'Notificar cuando se registra un monitoreo',
              description: 'Envía una notificación cuando se registra un monitoreo o seguimiento al incidente.'
            },
            SEND_EMAIL_INCIDENT_ASSESSMENT: {
              label: 'Notificar cuando se evalúa el impacto',
              description: 'Envía una notificación cuando se completa la evaluación de impacto del incidente.'
            },
            SEND_EMAIL_INCIDENT_ANNULLED: {
              label: 'Notificar cuando se anula un incidente',
              description: 'Envía una notificación cuando un incidente se anula.'
            },
            SEND_EMAIL_INCIDENT_MONITORING_EDITED: {
              label: 'Notificar cuando se edita un monitoreo',
              description: 'Envía una notificación cuando se modifica un monitoreo existente del incidente.'
            },
            SEND_EMAIL_INCIDENT_MONITORING_DELETED: {
              label: 'Notificar cuando se elimina un monitoreo',
              description: 'Envía una notificación cuando se elimina un monitoreo del incidente.'
            },
            SEND_EMAIL_INCIDENT_REASSESSED: {
              label: 'Notificar cuando se reevalúa el impacto',
              description: 'Envía una notificación cuando se registra una nueva versión de la evaluación de impacto.'
            },
            ASSESSMENT_CHANGE_SCOPE: {
              label: 'Alcance que dispara la notificación',
              description: 'Envía la notificación de reevaluación solo cuando cambia el nivel de impacto, o ante cualquier reevaluación.'
            }
          },
          recipients: {
            note: '“Para” recibe el aviso cuando no hay responsable asignado. Los correos en copia siempre reciben una copia. Presiona Enter o coma para separar varios correos.',
            master: 'Para',
            cc: 'CC',
            edit: 'Editar destinatarios',
            done: 'Listo',
            emptyMaster: 'Sin destinatario',
            emptyCc: 'Sin copias',
            optional: 'Opcional'
          },
          masterRecipient: {
            label: 'Destinatario de respaldo',
            placeholder: 'operaciones@teslatec.pe',
            validation: {
              required: 'Ingresa al menos un correo. Este campo es obligatorio.',
              invalid: 'No es un formato de correo: {emails}',
              tooMany: 'Máximo {max} destinatarios de respaldo.'
            }
          },
          extraRecipients: {
            placeholder: 'supervisor@teslatec.pe',
            invalid: 'Corrige el formato de: {emails}',
            tooMany: 'Máximo {max} direcciones en copia.'
          },
          template: {
            eyebrow: 'Plantilla de correo',
            configure: 'Configurar plantilla',
            none: 'Sin plantilla',
            custom: 'Personalizada',
            subject: 'Asunto',
            subjectPlaceholder: 'Asunto del correo',
            body: 'Cuerpo del mensaje',
            tabs: {
              edit: 'Editar',
              preview: 'Vista previa'
            },
            variables: {
              title: 'Variables disponibles',
              hint: 'Clic para insertar en {target}',
              subject: 'el asunto',
              body: 'el cuerpo'
            },
            vars: {
              incidente: {
                codigo: {
                  hint: 'Código correlativo del incidente',
                  sample: 'INC-2481'
                },
                titulo: {
                  hint: 'Título del incidente',
                  sample: 'Caída del enlace principal en Sede Lima'
                },
                estado: {
                  hint: 'Estado actual del incidente',
                  sample: 'En atención'
                },
                prioridad: {
                  hint: 'Prioridad asignada',
                  sample: 'Alta'
                }
              },
              usuario: {
                nombre: {
                  hint: 'Destinatario del correo',
                  sample: 'Yomar Huamani'
                }
              },
              fecha: {
                hint: 'Fecha y hora del evento',
                sample: '04/08/2026 09:14'
              },
              enlace: {
                hint: 'Enlace directo al registro',
                sample: 'https://giro.teslatec.pe/incidentes/INC-2481'
              },
              actor: {
                nombre: {
                  hint: 'Nombre de quien realizó la acción',
                  sample: 'Diana Torres'
                }
              },
              seguimiento: {
                descripcion: {
                  hint: 'Descripción del monitoreo',
                  sample: 'Se contactó al proveedor para coordinar el restablecimiento del enlace.'
                },
                fecha: {
                  hint: 'Fecha del monitoreo',
                  sample: '04/08/2026 08:30'
                }
              },
              evaluacion: {
                nivelAnterior: {
                  hint: 'Nivel de impacto antes de la reevaluación',
                  sample: 'Medio'
                },
                nivelNuevo: {
                  hint: 'Nivel de impacto tras la reevaluación',
                  sample: 'Alto'
                },
                version: {
                  hint: 'Número de versión de la evaluación',
                  sample: '2'
                }
              }
            },
            preview: {
              note: 'Vista previa con datos de ejemplo del incidente {code}.',
              from: 'De',
              to: 'Para',
              subject: 'Asunto',
              sender: 'Giro Incidentes <no-reply@giro.teslatec.pe>',
              recipient: 'usuario@empresa.com'
            },
            buttons: {
              reset: 'Restablecer predeterminada',
              cancel: 'Cancelar',
              save: 'Guardar plantilla'
            },
            messages: {
              saved: 'Plantilla guardada',
              reset: 'Se restableció la plantilla predeterminada',
              conflict: 'Esta plantilla fue modificada por otra persona. Se actualizó con la versión más reciente; revisa el contenido y guarda de nuevo.',
              saveError: 'No se pudo guardar la plantilla'
            }
          }
        },
        emailServer: {
          title: 'Servidor de correo',
          description: 'Configura el servidor SMTP usado para enviar notificaciones, invitaciones y resúmenes. Los cambios aplican a todas las aplicaciones del espacio de trabajo.',
          cardDescription: 'Configurar el servidor SMTP y las opciones de entrega de correo',
          parameterCode: 'Código del parámetro',
          defaultHostLabel: 'el servidor SMTP',
          status: {
            verified: 'Verificado',
            notVerified: 'No verificado'
          },
          sections: {
            template: {
              title: 'Plantilla',
              description: 'Cómo se identifican los mensajes salientes.'
            },
            connection: {
              title: 'Conexión y autenticación',
              description: 'Dónde y cómo se retransmiten los mensajes.'
            },
            delivery: {
              title: 'Opciones de entrega',
              description: 'Configuración de transporte y enrutamiento'
            }
          },
          fields: {
            from: {
              label: 'Remitente (From)',
              placeholder: 'Correo del remitente'
            },
            fromName: {
              label: 'Nombre del remitente',
              placeholder: 'Nombre a mostrar del remitente',
              tooltip: 'Nombre amigable mostrado como remitente de los correos salientes.'
            },
            replyTo: {
              label: 'Responder a',
              placeholder: 'Correo para respuestas'
            },
            replyToName: {
              label: 'Nombre de "responder a"',
              placeholder: 'Nombre a mostrar para la dirección de respuesta',
              tooltip: 'Nombre amigable mostrado para la dirección de respuesta.'
            },
            envelopeFrom: {
              label: 'Remitente del sobre',
              placeholder: 'Correo del sobre (envelope)',
              tooltip: 'Dirección de retorno usada para los rebotes (sobre SMTP).'
            },
            host: {
              label: 'Servidor (host)',
              placeholder: 'smtp.ejemplo.com'
            },
            port: {
              label: 'Puerto',
              placeholder: 'Puerto SMTP (por defecto 25)',
              suggested: 'Sugerido: {port}'
            },
            encryption: {
              label: 'Cifrado',
              ssl: 'Habilitar SSL',
              starttls: 'Habilitar StartTLS'
            },
            auth: {
              label: 'Autenticación',
              enabled: 'Habilitada',
              disabled: 'Deshabilitada'
            },
            username: {
              label: 'Usuario',
              placeholder: 'Usuario SMTP'
            },
            password: {
              label: 'Contraseña',
              placeholder: 'Contraseña SMTP',
              storedPlaceholder: 'Contraseña guardada — escriba una nueva para reemplazarla'
            },
            debug: {
              label: 'Habilitar depuración SMTP',
              tooltip: 'Escribe la transcripción completa SMTP en el log de la aplicación.'
            }
          },
          testInfo: 'Al probar la conexión se enviará un correo al usuario actual ({email}).',
          testing: 'Contactando a {host}…',
          buttons: {
            save: 'Guardar',
            test: 'Probar conexión',
            revert: 'Revertir'
          },
          dirty: {
            unsaved: 'Cambios sin guardar',
            saved: 'Todos los cambios guardados'
          },
          messages: {
            saved: 'Configuración del servidor de correo guardada.',
            saveError: 'No se pudo guardar la configuración del servidor de correo',
            loadError: 'No se pudo cargar la configuración del servidor de correo',
            testSuccess: 'Conexión exitosa. Se envió un correo de prueba a {email}.',
            testError: 'No se pudo conectar con el servidor SMTP',
            required: 'Requerido',
            invalidEmail: 'Ingrese un correo válido'
          }
        },
        transactionRules: {
          title: 'Reglas de Transacción',
          description: 'Definir reglas de negocio para transacciones'
        }
      }
    },
    events: {
      title: 'Eventos de pérdida',
      subtitle: 'Captura, categoriza y cierra pérdidas operativas de toda la organización.',
    createEvent: 'Registrar evento',
    export: 'Exportar',
    customise: 'Personalizar',
    saveEvent: 'Guardar Evento',
    stats: {
      openEvents: 'Eventos abiertos',
      grossLossYtd: 'Pérdida bruta YTD',
      netLossYtd: 'Pérdida neta YTD',
      avgTimeToClose: 'Tiempo prom. de cierre',
      trendVsLastWeek: 'vs semana pasada',
      trendThisMonth: 'este mes',
      trendRecovered: 'recuperado',
      trendVsLastQuarter: 'vs trimestre anterior',
    },
    severity: {
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Medio',
      low: 'Bajo',
    },
    tabs: {
      all: 'Todos',
      open: 'Abiertos',
      investigating: 'Investigando',
      recovered: 'Recuperados',
      closed: 'Cerrados',
    },
    columns: {
      id: 'ID Evento',
      date: 'Fecha',
      description: 'Descripción',
      type: 'Categoría',
      businessLine: 'Unidad de Negocio',
      severity: 'Severidad',
      grossLoss: 'Pérdida Bruta',
      netLoss: 'Pérdida Neta',
      status: 'Estado',
      owner: 'Responsable',
    },
    filters: {
      label: 'Filtros',
      status: 'Estado',
      severityTier: 'Severidad',
      lossEventType: 'Tipo de Evento',
      businessLine: 'Línea de Negocio',
      addYtd: '+ YTD',
    },
    groupBy: {
      label: 'Agrupar',
      none: 'Ninguno',
      lossEventType: 'Categoría',
      businessLine: 'Unidad de Negocio',
      status: 'Estado',
      severityTier: 'Severidad',
    },
    sortBy: {
      label: 'Ordenar',
      occurrenceDate: 'Fecha',
      externalCode: 'ID Evento',
      grossLoss: 'Pérdida Bruta',
      netLoss: 'Pérdida Neta',
    },
    date: {
      anytime: 'Cualquier fecha',
      olderThanWeek: 'Más de una semana',
      olderThanMonth: 'Más de un mes',
      olderThan6Months: 'Más de 6 meses',
      olderThanYear: 'Más de un año',
      customRange: 'Rango personalizado',
    },
    messages: {
      loadError: 'Error al cargar los eventos',
    },
    detail: {
      header: {
        titlePrefix: 'Evento',
        subtitle: 'Detalle del evento de pérdida',
        cancel: 'Cancelar',
      },
      navigation: {
        eventDetails: {title: 'Evento', subtitle: 'Información del evento'},
        financial: {title: 'Financiero', subtitle: 'Recuperaciones y pérdidas'},
        approval: {title: 'Aprobación', subtitle: 'Flujo de aprobación'},
        activity: {title: 'Actividad', subtitle: 'Notas y seguimiento'},
      },
    },
    form: {
      shortDescription: 'Descripción Corta',
      shortDescriptionRequired: 'La descripción corta es obligatoria',
      shortDescriptionPlaceholder: 'Ingrese una descripción breve del evento',
      detailedDescription: 'Descripción Detallada',
      detailedDescriptionPlaceholder: 'Describa en detalle el evento de pérdida',
      occurrenceDate: 'Fecha de Ocurrencia',
      discoveryDate: 'Fecha de Descubrimiento',
      accountingDate: 'Fecha Contable',
      severityTier: 'Nivel de Severidad',
      severityTierPlaceholder: 'Seleccione el nivel',
      lossEventType: 'Tipo de Evento',
      lossEventTypePlaceholder: 'Seleccione el tipo',
      businessLine: 'Línea de Negocio',
      businessLinePlaceholder: 'Seleccione la línea',
      grossLoss: 'Pérdida Bruta',
      netLoss: 'Pérdida Neta',
      status: 'Estado',
      statusPlaceholder: 'Seleccione el estado',
      saveSuccess: 'Evento guardado correctamente',
      createSuccess: 'Evento creado correctamente',
      saveError: 'Error al guardar el evento',
    },
    financial: {
      addRecovery: 'Agregar Recuperación',
      empty: 'Sin recuperaciones registradas',
      columns: {
        date: 'Fecha',
        type: 'Tipo',
        amount: 'Monto',
        description: 'Descripción',
      },
    },
    activity: {
      addNote: 'Agregar Nota',
      notePlaceholder: 'Ingrese una nota de seguimiento...',
      saveNote: 'Guardar Nota',
      empty: 'Sin notas registradas',
    },
    approval: {
      engineTitle: 'Motor de Aprobación',
      engineDescription: 'El flujo de aprobación se gestiona a través del motor compartido de aprobación.',
    }
  }
}
;
